module.exports = __webpack_public_path__ + "static/img/4.5ef942a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/eng/4.png
// module id = RgTj
// module chunks = 0